var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgArrowGreen(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "arrow-green_svg__right003"
  }, /*#__PURE__*/React.createElement("g", {
    id: "arrow-green_svg__Group_24",
    stroke: "#1ECD7F",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("path", {
    id: "arrow-green_svg__Path_3",
    d: "M14 9l3 3-3 3",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "arrow-green_svg__Path_4",
    d: "M17 12H7"
  })))));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgaWQ9InJpZ2h0MDAzIj4KPGcgaWQ9Ikdyb3VwIDI0Ij4KPHBhdGggaWQ9IlBhdGggMyIgZD0iTTE0IDlMMTcgMTJMMTQgMTUiIHN0cm9rZT0iIzFFQ0Q3RiIgc3Ryb2tlLXdpZHRoPSIxLjUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8cGF0aCBpZD0iUGF0aCA0IiBkPSJNMTcgMTJINyIgc3Ryb2tlPSIjMUVDRDdGIiBzdHJva2Utd2lkdGg9IjEuNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIi8+CjwvZz4KPC9nPgo8L3N2Zz4K";
export { SvgArrowGreen as ReactComponent };